(function () {
  if (window.__productGiftWrapCustomInstalled) return;
  window.__productGiftWrapCustomInstalled = true;

  function getProductGiftWrapCheckbox() {
    return document.querySelector('[data-gift-wrap-checkbox]');
  }

  function getProductGiftWrapNote() {
    return document.querySelector('[data-gift-wrap-note]');
  }

  function getProductGiftWrapNoteWrapper() {
    return document.querySelector('[data-gift-wrap-note-wrapper]');
  }

  function toggleProductGiftWrapNote() {
    const checkbox = getProductGiftWrapCheckbox();
    const noteWrapper = getProductGiftWrapNoteWrapper();

    if (!checkbox || !noteWrapper) return;

    noteWrapper.style.display = checkbox.checked ? 'block' : 'none';
  }

  function getGiftWrapData() {
    const checkbox = getProductGiftWrapCheckbox();
    const note = getProductGiftWrapNote();

    return {
      checked: checkbox?.checked === true,
      variantId: checkbox?.getAttribute('data-gift-wrap-variant-id') || '',
      productName: checkbox?.getAttribute('data-gift-wrap-product-name') || '',
      giftNote: note?.value || ''
    };
  }

  function createGiftWrapPairId() {
    return `gw_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }

  function isAovCartAddRequest(url) {
    const urlString = typeof url === 'string' ? url : url?.url;

    if (!urlString) return false;

    return urlString.includes('/cart/add') && urlString.includes('app=aov-ai-bundle');
  }

  function isGiftWrapAlreadyInItems(items, giftWrapVariantId) {
    return items.some((item) => {
      return String(item.id) === String(giftWrapVariantId);
    });
  }

  function addPairPropertiesToMainItems(items, pairId) {
    return items.map((item) => {
      return {
        ...item,
        properties: {
          ...(item.properties || {}),
          '_has_gift_wrap': 'true',
          '_gift_wrap_pair_id': pairId
        }
      };
    });
  }

  function createGiftWrapItem(giftWrapData, pairId) {
    return {
      id: Number(giftWrapData.variantId),
      quantity: 1,
      properties: {
        'Gift Note': giftWrapData.giftNote || '',
        'Product Name': giftWrapData.productName || '',
        '_gift_wrap_pair_id': pairId,
        '_gift_wrap_for': giftWrapData.productName || ''
      }
    };
  }

  const originalFetch = window.fetch;

  window.fetch = function () {
    const args = Array.from(arguments);
    const url = args[0];
    const options = args[1];

    if (isAovCartAddRequest(url) && options?.body) {
      const giftWrapData = getGiftWrapData();

      if (giftWrapData.checked && giftWrapData.variantId) {
        try {
          const body = JSON.parse(options.body);

          if (Array.isArray(body.items) && !isGiftWrapAlreadyInItems(body.items, giftWrapData.variantId)) {
            const pairId = createGiftWrapPairId();

            body.items = addPairPropertiesToMainItems(body.items, pairId);
            body.items.push(createGiftWrapItem(giftWrapData, pairId));

            args[1] = {
              ...options,
              body: JSON.stringify(body)
            };

            console.log('[GiftWrap] Added Geschenkverpackung to AOV cart/add request:', body);
          }
        } catch (error) {
          console.error('[GiftWrap] Failed to modify AOV cart/add request:', error);
        }
      }
    }

    return originalFetch.apply(this, args);
  };

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-gift-wrap-checkbox]')) {
      toggleProductGiftWrapNote();
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-gift-wrap-note]')) {
      // Value is read directly before AOV /cart/add request.
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    toggleProductGiftWrapNote();
  });
})();